<template>
    <div>
        <div class="container">
            <div class="main__top">
                <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s"> {{ artistInfo.stage_name }}</h1>
                <ul class="main__breadcrumbs wow zoomIn" data-wow-duration="1.5s">
                    <li><a href="/client/artists">My artists</a></li>
                    <li>{{ artistInfo.stage_name }}</li>
                </ul>
            </div>

            <TabContainer :space-between="true" :tabs="artistTabs"/>

        </div>
    </div>

</template>

<script>
import ProfileTitle from "../Common/ProfileTitle.vue";
import TabContainer from "../Common/TabContainer.vue";
import ArtistDetails from "./ArtistDetails.vue";
import ArtistShowsInformation from "./ArtistShowsInformation.vue";
import ArtistAvailabilityForClient from "./ArtistAvailabilityForClient.vue";
import {mapActions, mapState} from "pinia";
import {useClientStore} from "../../stores/ClientStore";

export default {
    name: 'ArtistProfileInner',
    components: {TabContainer, ProfileTitle},
    props: {
        artistId: Number
    },
    data() {
        return {
            artistTabs: [
                {id: 1, name: 'Artist Details', component: ArtistDetails},
                {id: 3, name: 'Shows Information', component: ArtistShowsInformation},
                {id: 4, name: 'Availability', component: ArtistAvailabilityForClient},
            ],

        }
    },
    computed: {
        ...mapState(useClientStore, {
            artistInfo: 'artistInfo',
        }),
    },
    methods: {
        ...mapActions(useClientStore, {
            fetchArtist: 'fetchArtist',
            fetchRegionList: 'fetchRegionList'
        }),
    },
    mounted() {
        this.fetchArtist(this.artistId)
        this.fetchRegionList()
    }


}

</script>


<style scoped>

</style>
